module.exports = __webpack_public_path__ + "static/media/TitlesBadOptimized.ca4b1ee2.jp2";